<template>
  <div :class="['price-badges', { 'price-badges--full-width': fullWidth }]">
    <div
      v-if="!singleBadge || singleBadge === 'monthly'"
      :class="[
        'price-badges__price-badge',
        'price-badges__price-badge--monthly',
        { 'price-badges__price-badge--single': singleBadge }
      ]"
    >
      <div class="price-badges__content">
        <span class="price-badges__text">from</span>
        <h2 class="price-badges__price">&euro;{{ formattedMonthlyPrice }}</h2>
        <span class="price-badges__text">/mo</span>
      </div>
      <base-tooltip class="price-badges__tooltip">
        {{ $t("shared.monthly-badge") }}
      </base-tooltip>
    </div>
    <div
      v-if="!singleBadge || singleBadge === 'car-price'"
      :class="[
        'price-badges__price-badge',
        'price-badges__price-badge--car-price',
        { 'price-badges__price-badge--single': singleBadge }
      ]"
    >
      <h2 class="price-badges__price">&euro;{{ formattedCarPrice }}</h2>
    </div>
  </div>
</template>

<script>
import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";

export default {
  name: "BasePriceBadges",
  components: {
    BaseTooltip
  },
  props: {
    monthlyPrice: {
      type: Number,
      default: 0
    },
    carPrice: {
      type: Number,
      default: 0
    },
    singleBadge: {
      type: String,
      default: ""
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedCarPrice() {
      return this.carPrice.toLocaleString();
    },
    formattedMonthlyPrice() {
      return Math.ceil(this.monthlyPrice);
    }
  }
};
</script>

<style scoped lang="scss">
.price-badges {
  display: flex;

  &__price-badge {
    padding: 13px 20px;
    display: flex;
    color: $color-white;

    &--monthly {
      background-color: $color-brown-200;
      position: relative;

      .price-badges__price {
        margin: 0 8px;
      }
    }

    &--car-price {
      background-color: $color-brown-100;
    }

    &--single {
      width: 100%;
      display: flex;
      justify-content: center;

      .price-badges__content {
        margin: 0 auto;
        padding-left: 25px;
      }
    }
  }

  &__content {
    display: flex;
  }

  &__text {
    text-transform: uppercase;
    opacity: .5;
    font-size: $font-size-s;
  }

  &__price {
    margin: 0;
  }

  &__tooltip {
    margin-left: 9px;
    align-self: center;
  }
}

@media screen and (min-width: $media-l) {
  .price-badges--full-width .price-badges__price-badge {
    justify-content: center;

    &--monthly {
      @include flex-basis(50%);
    }

    &--car-price {
      @include flex-basis(50%);
    }
  }

  .price-badges--full-width .price-badges__content {
    margin: 0 auto;
    padding-left: 25px;
  }
}

@media screen and (min-width: $media-l),
  (-ms-high-contrast: active),
  (-ms-high-contrast: none) {
  .price-badges__price-badge--single .price-badges__content {
    margin: 0;
  }

  .price-badges--full-width .price-badges__content {
    margin: 0;
  }
}
</style>
